<template>
  <div class="report-creation-container">
    <div class="wizard-container">
    
      <select-mea-wizard v-if="showSection(0)"></select-mea-wizard>
      <select-indicator-wizard v-if="showSection(1)"></select-indicator-wizard>
      <select-data-source-wizard v-if="showSection(2)"></select-data-source-wizard>
      <report-name-wizard v-if="showSection(3)" v-on:updateReportName="updateReportName"></report-name-wizard>
      <report-container  v-if="showSection(4)" :comparative="comparativeResult"></report-container >
    </div>
    
  </div>
</template>

<script type="text/javascript">
import { mapState } from 'vuex';
import SelectIndicatorWizard from './SelectIndicatorWizard';
import SelectMeaWizard from './SelectMeaWizard';
import SelectDataSourceWizard from './SelectDataSourceWizard';
import ReportNameWizard from './ReportNameWizard';
import Loading from 'vue-full-loading';
import MapDisplay from './MapDisplay';
import ReportDisplay from './ReportDisplay';
import ReportContainer from './ReportContainer';
import ReportConfigWizard from './ReportConfigWizard';
import store from '../../store.js';
import constants from '../../constants';
import _ from 'lodash';
import $ from 'jquery';
import { ReportWizard, Indicator } from '../../api';
import ReportWizardNavigation from './ReportWizardNavigation';


export default {
  updated(){
    if (this.sectionNumber > Object.keys(this.placement).length) {
      $('.footer-nav').hide();
    }
  },
  data() {
    return {
      comparativeResult: false
    };
  },
  computed:{
    ...mapState({
      sectionNumber: state => state.sectionNumber,
      showAdvancedFilter: state => state.showAdvancedFilter,
      reportObject: state => state.reportObject,
      loading: state => state.loading,
      placement: state => state.placement
    }),
    reports: () => {
      let reports = [];
      if (store.state.reports !== null) {
        reports = store.state.reports;
      }
      return reports;
    },
  },
  methods: {
    showSection: function (sectionNumber) {
      return this.sectionNumber === sectionNumber ? true : false;
    },
    updateReportName: function(value) {
      this.reportObject['name'] = value;

    },
  },
  beforeRouteEnter (to, from, next) {
    let id = to.params.id;
    store.dispatch('fetchReports');
    next();
  },
  components:{
    SelectIndicatorWizard,
    SelectMeaWizard,
    SelectDataSourceWizard,
    ReportNameWizard,
    MapDisplay, Loading, ReportDisplay,
    ReportContainer,
    ReportConfigWizard,
    ReportWizardNavigation
  }
};
</script>
<style lang="scss" scoped>
.report-creation-container{
  height:100%;
}

.tab-bar {
    margin-bottom: 0rem;
}
.footer-nav{
  height: 52px;
  background-color: #06bafc;
  margin-right: -25px;
  margin-left: -25px;
}
.wizard-container{
  height: calc(100% - 52px);
}

@media (max-width: 720px){
  .report-creation-container .wizard-container .list-container {
    h1.detail-title{
      padding-top: 15px;
      font-size: 1.125em;
      height: 62px;
    }
    i.aux-sidebar{
      padding-top: 5px;
    }
  }

}

@media (max-width: 720px){
  .eis-content{
    height: 85%;
  }
}


</style>



// WEBPACK FOOTER //
// src/components/report/ReportCreationWizard.vue